<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">
      {{ `${warehouse.company_name}` }} -
      {{ $t("COMMON.LOGS") }}
    </h3>
    <log-list-table :filterSubject="warehouse" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "warehouse-view-logs",

  components: { LogListTable },

  props: ["warehouse"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
